import { useEffect, useMemo } from 'react';
import { matchPath, Outlet, useLocation } from 'react-router-dom';

import { useRemoveDetailsPlotGroup } from '@/components/PlotGroups/hooks/useRemoveDetailsPlotGroup';
import { useIsPlotPage } from '@/hooks/useIsPlotPage';
import { usePathSet } from '@/hooks/usePathSet';

export const PlotGroupDetailsCleaner = () => {
  const pathSet = usePathSet();
  const { removeDetailsPlotGroup } = useRemoveDetailsPlotGroup();
  const { pathname } = useLocation();
  const isPlotPath = useIsPlotPage();

  const routesWithDetailsPlotGroups = useMemo(
    () => [
      pathSet.details,
      pathSet.plotGroupPlots,
      pathSet.impactProjections,
      pathSet.impactProjectionsV2,
      pathSet.biodiversityDetails,
      pathSet.soilDetails,
      pathSet.waterDetails,
      pathSet.carbonDetails,
      pathSet.socialDetails,
    ],
    [pathSet],
  );

  useEffect(() => {
    const isDetailsPlotGroupRoute =
      isPlotPath || routesWithDetailsPlotGroups.some((allowedRoute) => matchPath(allowedRoute, pathname));

    if (!isDetailsPlotGroupRoute) {
      removeDetailsPlotGroup();
    }
  }, [pathname, removeDetailsPlotGroup, routesWithDetailsPlotGroups, isPlotPath]);

  return <Outlet />;
};
